import { IBaseResponse } from 'New/groups/services/groups'
import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import ToastMessager from 'Components/toast-messager'

export interface IColumnHeadColumnInfo {
  background_color: string
  background_image_url: string
  column_id: number
  description: IColumnHeadColumnInfoDesc
  group_id_str: string
  group_info: string
  logo: string
  pop_title: string
  publish_time: number
  related_series: IColumnHeadSeriesInfo[]
  scheme: string
  series_title: string
  tags: IColumnHeadColumnInfoColumnTag[]
  title: string
  total_periods: string
}
export interface IColumnHeadColumnInfoColumnTag {
  height: number
  image_url: string
  scheme: string
  title: string
  width: number
}
export interface IColumnHeadColumnInfoDesc {
  background_color: string
  description: string
  host_user: IColumnHeadUserInfo[]
  title: string
  user: IColumnHeadUserInfo
}
export interface IColumnHeadSeriesInfo {
  count: number
  series_id: number
  series_name: string
}
export interface IColumnHeadUserInfo {
  auth_v_type: number
  avatar_url: string
  berified_avatar_url: string
  description: string
  is_followed: boolean
  name: string
  profile_url: string
  scheme: string
  user_id: number
}
export interface IColumnShareInfo {
  extra: IColumnShareInfoExtra
  share_image: string
  share_text: string
  share_url: string
  title: string
  weixin_share_schema: string
  weixin_special_type: number
}

export interface IColumnShareInfoExtra {
  category_list: string[]
}

export interface IGetColumnInfoHeadResponseData {
  list: IGetColumnInfoHeadResponseDataCardInfo[]
  share_info: IColumnShareInfo
  tab: IGetColumnInfoHeadResponseDataTabInfo[]
  user: IColumnHeadUserInfo
}
export interface IGetColumnInfoHeadResponseDataCardInfo {
  card_id: number
  duplicate: boolean
  info: IColumnHeadColumnInfo
  type: number
  unique_id: number
  unique_id_str: string
}
export interface IGetColumnInfoHeadResponseDataTabInfo {
  elevator: string
  name: string
  tid: number
}

export interface IFetchGroupInfoParams {
  column_id: number
}

// 顶部信息
export const fetchColumnInfo = async function (
  params: IFetchGroupInfoParams,
  req: any
) {
  const json: IBaseResponse<IGetColumnInfoHeadResponseData> = await fetch(
    getUrl(
      `/motor/pc/content/column/info/head?${serializeObject(params)}`,
      'motor.pc_content.api'
    ),
    {
      req,
    }
  )

  if (0 !== json?.status) {
    throw Error(json?.prompts || json.message)
  }
  return json?.data
}

export interface IEpisode {
  episode: number //当前期数
  publish_time: number // 视频发布时间
  title: string //视频标题
  unique_id: number // gid
  unique_id_str: string // gid string
  article_type: number
  video_info: IVideoInfo // 视频详情信息
}

export interface IEpisodeList {
  program_list: IEpisode[] //期数信息111
  has_more: boolean // 是否还有数据
  total: number
}

export interface IVideoInfo {
  cover_url: string //封面图信息
  video_duration: number // 视频时长
  video_id: string //视频vid
  video_size: string // 视频大小list, 样例："{"1080p":{"duration":1219.263,"file_size":677901428,"h":1080,"w":1920},"4k":{"duration":1219.263,"file_size":2560095563,"h":2160,"w":3840},"high":{"duration":1219.267,"file_size":61686236,"h":480,"w":854},"normal":{"duration":1219.267,"file_size":63017752,"h":360,"w":640},"ultra":{"duration":1219.263,"file_size":201829423,"h":720,"w":1280}}"
  video_type: number
  video_watch_count: number //视频观看人数
}

export interface IFetchEpisodeParams {
  count: number
  page: number
  series_id: number
  column_id: number
  source: number
}

export const fetchEpisodeByColumnId = async (params: IFetchEpisodeParams) => {
  const json: IBaseResponse<IEpisodeList> = await fetch(
    getUrl(
      `/motor/pc/content/get_episode_by_column_id?${serializeObject(params)}`
    )
  )

  if (0 !== json?.status) {
    throw Error(json?.prompts || json.message)
  }

  return json?.data
}

interface IFocusParams {
  user_id: number | string
  to_user_id: number | string
}
export const unlike = async (params: IFocusParams) => {
  return fetch('/motor/user/relation/pc_unlike', {
    method: 'POST',
    headers: {
      'tt-anti-token': window.localStorage.getItem('tt-anti-token') || '',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: serializeObject(params),
  })
    .then((res) => {
      const { message, is_following } = res?.data || {}
      if (message === 'success' && !is_following) {
        return Promise.resolve()
      } else {
        ToastMessager.show({
          text: '取消关注失败',
        })
        return Promise.reject('取消关注失败')
      }
    })
    .catch(() => {
      ToastMessager.show({
        text: '取消关注失败',
      })
      return Promise.reject('取消关注失败')
    })
}

export const fetchIsFollowed = async (toUserId: number) => {
  const json: IBaseResponse<{ is_following: boolean }> = await fetch(
    getUrl(`/motor/pc/content/follow?to_user_id=${toUserId}`)
  )

  if (0 !== json?.status) {
    throw Error(json?.prompts || json.message)
  }

  return json?.data
}
